import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class GameTransactionsService {
  
  public customer: CustomerModel;

  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService
    ) { 

    this.userSession.getCustomer().subscribe(
      (customer) => {
          this.customer = customer;
      }
  );

  }

  public callSendTransfers(date_from: string, date_to: string) {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        date_from: date_from,
        date_to: date_to
    }

    return this.webservice.post('games/send-transfers', obj);
  } 

  public callGetTransfers(date_from: string, date_to: string, page: number = 1, numRecords: number = 25) {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        date_from: date_from,
        date_to: date_to,
        page: page,
        num: numRecords
    }

    return this.webservice.get('games/get-transfers', obj);
  }
}
